import { PharmacyDirectory } from 'generated/api';
import { api } from 'careand-redux/api/ApiThunks';
import { createResettableSlice } from 'careand-redux/utils/makeResettable';
import { unwrapApi } from 'careand-redux/utils/unwrap';

export interface PharmaciesState {
  pharmacies: PharmacyDirectory[];
  searchTerm?: string;
}

const initialState: PharmaciesState = {
  pharmacies: [],
};

const slice = createResettableSlice({
  name: 'Pharmacies',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder.addCase(
      api.Pharmacies.getPharmacies.fulfilled,
      unwrapApi((state, pharmacies, req) => {
        state.pharmacies = pharmacies;
        state.searchTerm = req.name;
      }),
    ),
});

export const pharmacyActions = slice.actions;
export default slice.reducer;
